import axios from "axios";

export const getPeople = async () => {
	return axios.get("/people")
		.catch(err => err);
}